var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7879_154115)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.125 0H1.875C0.8438 0 0 0.8438 0 1.875V18.1248C0 19.1562 0.8438 19.9998 1.875 19.9998L18.125 20C19.1562 20 20 19.1562 20 18.125V1.875C20 0.8438 19.1562 0 18.125 0ZM13.6804 6.3944C13.032 5.9718 12.5642 5.2952 12.4182 4.5068C12.3868 4.3366 12.3692 4.1612 12.3692 3.9818H10.3L10.2966 12.2748C10.2618 13.2034 9.4974 13.9488 8.5606 13.9488C8.2692 13.9488 7.9952 13.8762 7.7536 13.749C7.2 13.4576 6.821 12.8774 6.821 12.2096C6.821 11.2504 7.6014 10.47 8.5604 10.47C8.7394 10.47 8.9112 10.4996 9.0736 10.5502V8.4378C8.9054 8.4148 8.7346 8.4006 8.5604 8.4006C6.4602 8.4006 4.7518 10.1092 4.7518 12.2096C4.7518 13.498 5.3954 14.6384 6.3778 15.328C6.9964 15.7624 7.7492 16.0182 8.5606 16.0182C10.6608 16.0182 12.3692 14.3096 12.3692 12.2096V8.0042C13.1808 8.5866 14.1752 8.9298 15.2482 8.9298V6.8606C14.6704 6.8606 14.1322 6.6888 13.6804 6.3944Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7879_154115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok-icon.7c8ac5be5d4b274b04431cfbe22f03ba.svg";
export { ForwardRef as ReactComponent };